import React, { FC } from 'react'

import styled from 'styled-components'
import { RadioProps } from 'antd'
import { useSelector } from 'react-redux'

import { PaymentMethodEnum, WalletPaymentMethod } from 'src/Constants/enums'
import { getResolvedTheme } from 'src/Redux/theme-process'
import { MAX_TABLET_WIDTH } from 'src/Styled/variables'
import { getPaymentMethodsForCountry } from 'src/Utils/paymentMethods'
import { PrimaryRadio } from 'src/Components/PrimaryRadio'

const Text = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  white-space: nowrap;
`
const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  @media screen and (min-width: ${MAX_TABLET_WIDTH}) {
    flex-direction: row;
    align-items: center;
    align-self: stretch;
  }
`
const ImagesContainer = styled.div`
  display: flex;
  min-width: 240px;
  align-items: center;
  align-content: center;
  gap: 8px;
  flex: 1 0 0;
  flex-wrap: wrap;

  @media screen and (max-width: ${MAX_TABLET_WIDTH}) {
    margin-left: -24px;
    margin-right: -16px;
  }
`
const ImagesCard = styled.div`
  display: flex;
  width: 48px;
  height: 24px;
  justify-content: center;
  align-items: center;
  border: 1px solid ${({ theme }) => theme.color.lightGrey};
  border-radius: 8px;
  background-color: ${({ theme }) => theme.color.hoverWhite};
`

const StyledPrimaryRadio = styled(PrimaryRadio)`
  align-items: normal;

  &.ant-radio-wrapper-disabled ${ImagesContainer} {
    display: none;
  }
  &.ant-radio-wrapper-disabled ${Text} {
    color: ${({ theme }) => theme.color.slateGrey};
  }
  &.ant-radio-wrapper .ant-radio {
    align-self: inherit;
    padding-top: 2px;
    @media screen and (min-width: ${MAX_TABLET_WIDTH}) {
      padding-top: 0;
      align-self: center;
    }
  }
`

interface Props extends RadioProps {
  countryCode?: string
  walletPaymentMethods?: WalletPaymentMethod[]
}

export const StripeRadioButton: FC<Props> = ({
  countryCode = 'US',
  walletPaymentMethods,
  ...props
}) => {
  const resolvedTheme = useSelector(getResolvedTheme)
  const isDarkTheme = resolvedTheme === 'dark'

  const paymentMethods = getPaymentMethodsForCountry(
    countryCode,
    walletPaymentMethods,
  )

  return (
    <StyledPrimaryRadio {...props} value={PaymentMethodEnum.STRIPE}>
      <Container>
        <Text>Сredit & debit сards</Text>
        <ImagesContainer>
          {paymentMethods.map(({ id, Component, ComponentDark }) => {
            const Logo = isDarkTheme ? ComponentDark : Component

            return (
              <ImagesCard key={id}>
                <Logo />
              </ImagesCard>
            )
          })}
        </ImagesContainer>
      </Container>
    </StyledPrimaryRadio>
  )
}
